<template>
	<div>
		<template v-if="type == 'mobile'">
			<div class="border-b-semi-grey">
				<div class="border-semi-grey radius-12 w-100 py-4 mb-5">
					<div class="px-3 mb-3 text-center">
						<p class="heading-6 mb-0">{{data.upselling_product_group.name}}</p>
		    		<!-- <p class="body-2-2-1">{{data.sub_tagline}}</p> -->
					</div>
					<div class="w-100 mb-3 px-3" v-if="data.upselling_product_group.slider.length == 1" style="height: 189px !important;">
	          <img :src="data.upselling_product_group.slider[0].image_url" class="img-fit" height="189">
	        </div>
	    		<div v-if="data.upselling_product_group.slider.length > 1" class="mb-4">
		    		<flickity ref="flickity" :options="$freeScrollSliderOption">
				      <div class="carousel-cell w-90 mr-2" :id="slide.id" v-for="(slide, index) in data.upselling_product_group.slider"
				      	:class="{'pl-3':index == 0, 'pr-3':index == data.upselling_product_group.slider.length - 1}">
				        <div class="w-100" style="height: 189px !important;">
				          <img :src="slide.image_url" class="img-fit radius-6" height="189">
				        </div>
				      </div>
				    </flickity>
				  </div>
				  <div class="mb-4" v-if="data.upselling_product_group.group.length > 0">
				  	<div class="mb-3">
					  	<!-- <p class="body-1-2 mb-0">{{data.upselling_product_group.name}}</p> -->
			    		<!-- <p class="body-2-2-1">{{data.upselling_product_group.name}}</p> -->
			    	</div>
			    	<div class="w-100 mb-4" @click="goToDetail" >
			    		<p class="heading-6 text-16 mb-0 px-3">{{data.upselling_product_group.group[0].title}}</p>
		    			<p class="body-2-2-1 px-3">{{data.upselling_product_group.group[0].sub_title}}</p>
			    		<flickity ref="flickity" :options="$freeScrollSliderOption" v-if="data.upselling_product_group.group[0].product.length > 1">
			    			<div class="carousel-cell w-75 mr-2" style="height:235px !important;" :id="data.upselling_product_group.group[0].id" v-for="(product, index) in data.upselling_product_group.group[0].product" :class="{'pl-3':index == 0, 'pr-3':index == data.upselling_product_group.group[0].product.length - 1}">
			    				<VoucherItem
					    		:data="product" />
			    			</div>
			    		</flickity>
			    		<div class="px-3" v-else v-for="product in data.upselling_product_group.group[0].product">
			    			<div class="w-100 mr-2" style="height:235px !important;" :id="data.upselling_product_group.group[0].id" v-for="product in data.upselling_product_group.group[0].product">
			    				<VoucherItem
					    		:data="product" />
			    			</div>
			    		</div>
			    	</div>
				  </div>
				  <div class="py-2 px-3 border-semi-grey radius-6 mr-3 ml-auto d-table cursor-pointer" @click="goToDetail">
			    	<p class="mb-0 text-green body-2 d-inline-block aling-middle">{{$t('hotel.concierge.fitur.see-more-voucher')}}</p>
	      		<i class="iconsmind-Arrow-Right font-weight-bold d-inline-block aling-middle text-12 text-green"></i>
			    </div>
			  </div>
			</div>
		</template>

		<template v-if="type == 'desktop'">
			<div class="py-4 border-semi-grey radius-12">
				<div class="px-4 mb-3">
					<p class="heading-6 mb-0">{{data.upselling_product_group.name}}</p>
	    		<p class="body-2-2-1">{{data.upselling_product_group.sub_tagline}}</p>
				</div>
				<div class="w-100 mb-4 px-3" v-if="data.upselling_product_group.slider.length == 1" style="height: 189px !important;">
          <img :src="data.upselling_product_group.slider[0].image_url" class="img-fit" height="189">
        </div>
    		<div v-if="data.upselling_product_group.slider.length > 1" class="pl-4 mb-4">
	    		<flickity ref="flickity" :options="$freeScrollSliderOption">
			      <div class="carousel-cell w-75 mr-4" :id="slide.id" v-for="slide in  data.upselling_product_group.slider">
			        <div class="w-100" style="height: 189px !important;">
			          <img :src="slide.image_url" class="img-fit radius-6" height="189">
			        </div>
			      </div>
			    </flickity>
			  </div>
			  <div class="pl-4 mb-4" v-if="data.upselling_product_group.group.length > 0">
			  	<div class="mb-3">
				  	<!-- <p class="body-1-2 mb-0">{{data.upselling_product_group.name}}</p> -->
		    		<!-- <p class="body-2-2-1">{{data.upselling_product_group.name}}</p> -->
		    	</div>
		    	<div class="w-100 mb-4" @click="goToDetail">
		    		<p class="heading-6 text-16 mb-0">{{data.upselling_product_group.group[0].title}}</p>
	    			<p class="body-2-2-1">{{data.upselling_product_group.group[0].sub_title}}</p>
		    		<flickity ref="flickity" :options="$freeScrollSliderOption">
		    			<div 
								class="carousel-cell mr-2"
								:class="{
									'w-25': data.upselling_product_group.group[0].product.length == 4,
									'w-30': data.upselling_product_group.group[0].product.length == 3,
									'w-50': data.upselling_product_group.group[0].product.length == 2,
									'w-100': data.upselling_product_group.group[0].product.length == 1,
									'product-big-wrapper': data.upselling_product_group.group[0].product.length > 4,
								}"
								:id="data.upselling_product_group.group[0].id"
								v-for="product in data.upselling_product_group.group[0].product">
		    				<VoucherItem
					    		:data="product" />
		    			</div>
		    		</flickity>
		    	</div>
			  </div>
			  <div class="py-2 px-3 border-semi-grey radius-6 mr-3 ml-auto d-table cursor-pointer" @click="goToDetail">
		    	<p class="mb-0 text-green body-2 d-inline-block aling-middle">{{$t('hotel.concierge.fitur.see-more-voucher')}}</p>
      		<i class="iconsmind-Arrow-Right font-weight-bold d-inline-block aling-middle text-12 text-green"></i>
		    </div>
			</div>
		</template>
		
	</div>
</template>
<script>
  import Flickity from 'vue-flickity';
  import {mapGetters} from 'vuex';
  import VoucherItem from '@/components/hotel/general/VoucherItem';

	export default{
		components:{
			VoucherItem,
			Flickity
		},
		props:['type','data'],
		data(){
			return{
				voucherSliderOption: {
          initialIndex: 0,
          autoPlay: false,
          prevNextButtons: false,
          pageDots: true,
          adaptiveHeight: false,
          draggable: true,
          wrapAround: true,
        },
			}
		},
		computed:{
			...mapGetters(['getMerchant']),
		},
		mounted(){
		},
		methods:{
			goToDetail(){
				this.$postLog('HOME','MODULE PREVIEW',`Clicked detail ${this.data.upselling_product_group.code}`)
				this.$router.push(`/${this.getMerchant.code}/upselling/${this.data.upselling_product_group.id}`)
			}
		}
	}
</script>
<style>
	.product-small{
		width:100px;
		height:100px;
	}
	.product-small-wrapper{
		width:100px;
	}
	.product-big{
		width:230px;
		height:164px;
	}
	.product-big-wrapper{
		width:230px;
	}
</style>


// WEBPACK FOOTER //
// src/components/hotel/general/VoucherPreview.vue